import { render, staticRenderFns } from "./docDetail.vue?vue&type=template&id=b3819114&scoped=true"
import script from "./docDetail.vue?vue&type=script&lang=ts"
export * from "./docDetail.vue?vue&type=script&lang=ts"
import style0 from "./docDetail.vue?vue&type=style&index=0&id=b3819114&prod&scoped=true&lang=scss"
import style1 from "./docDetail.vue?vue&type=style&index=1&id=b3819114&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3819114",
  null
  
)

export default component.exports